var r={year:"year",month:"month"};export{r as DATE_TYPE};
//# sourceMappingURL=dateTime.types.js.map
